import React from 'react';
import d3 from 'd3';

const getTooltipTitle = (props,xval) => {
    let retval = null;
    if(typeof props.tooltipTitle === "string" && xval) {
        retval = <div className="chartTooltip_title">{props.tooltipTitle}</div>    
    } else if(typeof props.tooltipTitle === "function" && xval) {
        retval = <div className="chartTooltip_title">{props.tooltipTitle(xval)}</div>
    }   
    return retval;
};

export default class PointsTooltip extends React.Component {
    render() {
        //if(!this.context.mouseX || !this.context.mouseY) { return null; }
        let tooltiptextarr = this.props.data.map((dataobj) => {
            let xcoords = dataobj.series.map((val) => this.props.xScale(val[0]));
            let innerspacings = xcoords.reduce((prev,cur,i,arr) => {
                if(i>0) {
                    prev.push(Math.min((arr[i]-arr[i-1])/2,this.props.closeness));
                }
                return prev;
            },[]);
            let spacings = [this.props.closeness,...innerspacings,this.props.closeness];    
            let minindex = 0;
            let distances = xcoords.map((val) => val - this.context.mouseX);
            for(let i=0;i<distances.length;i++) {
                if(Math.abs(distances[i]) < Math.abs(distances[minindex])) {
                    minindex = i;
                }
            }
            if((distances[minindex]>=0 && Math.abs(distances[minindex])<spacings[minindex]) || 
                (distances[minindex]<0 && Math.abs(distances[minindex])<spacings[minindex+1])) {
                let pointdistance = distances[minindex]>=0?Math.abs(distances[minindex]):Math.abs(distances[minindex]);
                if(this.props.tooltipFormatter) {
                    return {
                        xval: dataobj.series[minindex][0],
                        yval: dataobj.series[minindex][1],
                        text: this.props.tooltipFormatter(dataobj.name, dataobj.series[minindex][0], dataobj.series[minindex][1]),
                        pointdistance: pointdistance,
                        color: dataobj.color || null
                    }    
                } else {
                    return {
                        xval: dataobj.series[minindex][0],
                        yval: dataobj.series[minindex][1],
                        text: dataobj.name + ": " + dataobj.series[minindex][1],
                        pointdistance: pointdistance,
                        color: dataobj.color || null
                    }
                }
                
            }
            return null;
        });
        tooltiptextarr = tooltiptextarr.filter((v) => v!=null);
        if(tooltiptextarr.length>0) {
            var closestx = tooltiptextarr.reduce((prev,cur) => (!prev||cur.pointdistance<prev.pointdistance)?cur:prev).xval;
            tooltiptextarr = tooltiptextarr.filter((v) => JSON.stringify(v.xval)==JSON.stringify(closestx));
        }
        let tooltipWidth = this.props.tooltipWidth || 200;
        let tooltipx = this.context.mouseX;
        if(tooltipx > this.props.width/2) {
            tooltipx -= tooltipWidth;
        }
        
        //if(tooltiptextarr.length>0) {
            return <foreignObject 
                    x={tooltipx} 
                    y={this.context.mouseY}>
                    <div style={{position:"relative"}}>
                        <div className="chartTooltip" style={{
                            position:"absolute",
                            width:tooltipWidth+"px",
                            visibility: tooltiptextarr.length>0?'visible':'hidden',
                            zIndex:1000
                        }}>
                            {getTooltipTitle(this.props,closestx)}
                            {tooltiptextarr.map((val) => <p style={{color:val.color}}>{val.text}</p>)}
                        </div>
                    </div>
                </foreignObject>
        /*} else {
            return null;
        }*/
    }
}

PointsTooltip.contextTypes = {
    mouseX: React.PropTypes.number,
    mouseY: React.PropTypes.number
};


// WEBPACK FOOTER //
// ./src/js/components/charting/PointsTooltip/PointsTooltip.jsx